import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";

function ServicableArea() {
  const [city, setCity] = useState("");
  const [area, setArea] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [service, setService] = useState([]);

  const [editItemId, setEditItemId] = useState(null);
  console.log(service, "fdhgfhghj");
  const getServiceArea = async () => {
    try {
      const response = await privateRequest.get(`ServiceArea/service`);
      setService(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteServiceArea = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `ServiceArea/service/${_id}`
        );
        getServiceArea();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const AddServicable = async (event) => {
    event.preventDefault();
    try {
      if (editItemId) {
        await privateRequest.put(`ServiceArea/service/${editItemId}`, {
          city,
          area,
        });
        setEditItemId(null);
      } else {
        await privateRequest.post(`ServiceArea/service`, { city, area });
      }
      getServiceArea();
      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: editItemId
          ? "ServicableArea updated successfully!"
          : "ServicableArea added successfully!",
      });
      setCity("");
      setArea("");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getServiceArea();
  }, []);

  const handleLocationChange = (e) => {
    const inputLocation = e.target.value;
    if (inputLocation && window.google && window.google.maps) {
      const autocompleteService =
        new window.google.maps.places.AutocompleteService();
      autocompleteService.getPlacePredictions(
        { input: inputLocation },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions &&
            predictions.length > 0
          ) {
            const placeId = predictions[0].place_id;
            const placesService = new window.google.maps.places.PlacesService(
              document.createElement("div")
            );
            placesService.getDetails(
              { placeId },
              (placeResult, placesServiceStatus) => {
                if (
                  placesServiceStatus ===
                  window.google.maps.places.PlacesServiceStatus.OK
                ) {
                  const { formatted_address, address_components } = placeResult;
                  let cityName = "";
                  let areaName = "";
                  address_components.forEach((component) => {
                    if (component.types.includes("locality")) {
                      cityName = component.long_name;
                    } else if (component.types.includes("neighborhood")) {
                      areaName = component.long_name;
                    }
                  });
                  setCity(cityName);
                  setArea(areaName);
                }
              }
            );
          }
        }
      );
    }
  };

  return (
    <>
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Servicable Area</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => setShowModal(true)}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table className="table table-striped table-hover table-sm dataTable no-footer text-center">
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col" style={{ width: "300px" }}>
                              City
                            </th>
                            <th scope="col">Area</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {service.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">{item?.city}</td>
                              <td className="align-center">{item?.area}</td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      setEditItemId(item._id);
                                      setCity(item.city);
                                      setArea(item.area);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteServiceArea(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addAreaModal"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Servicable Area
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddServicable}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="mb-0">Search Location</label>
                      <input
                        type="text"
                        id="inputlocation"
                        className="form-control"
                        placeholder="Search Location"
                        onChange={handleLocationChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="mb-0">City Name</label>
                      <input
                        type="text"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        id="inputcityName"
                        className="form-control"
                        placeholder="City Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="mb-0">Area Name</label>
                      <input
                        type="text"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                        id="inputareaName"
                        className="form-control"
                        placeholder="Area Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select className="form-control">
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServicableArea;
